// import Main from '@/pc/views/Main'
// import Index from '@/pc/views/Index'
// import Trade from '@/pc/views/Trade'
// import Wallet from '@/pc/views/Wallet'

// -----------------------------------------mobile區開始
import MainMobile from '@/mobile/views/Main'
import IndexMobile from '@/mobile/views/Index'

export default ({
  defaultRoutes: [
    {
      path: '/',
      component: () => import(/* webpackChunkName: "Info" */ '@/pc/views/Main'),
      name: 'Main',
      children: [
        // 主頁
        { path: '', component: () => import(/* webpackChunkName: "Info" */ '@/pc/views/Index'), name: 'HOME PAGE', label: 'HomePage', id: '0-1' },
        // 主頁書籤_介紹萬達
        { path: '/#productArea', component: () => import(/* webpackChunkName: "Info" */ '@/pc/views/Index'), name: 'PRODUCT AREA', label: 'ProductArea', id: '1-1' },
        // 交易所 // router-view在main裡面,但此頁連結寫在index中,所以path加上/  =>帶回根目錄
        // { path: '/trade', component: () => import(/* webpackChunkName: "Info" */ '@/pc/views/Trade'), name: 'CRYPTOCURRENCY', id: '2-1' },
        // 錢包
        // { path: '/wallet', component: () => import(/* webpackChunkName: "Info" */ '@/pc/views/Wallet'), name: 'WALLET APP', id: '3-1' },
        // 主頁書籤_介紹萬達
        { path: '/#aboutArea', component: () => import(/* webpackChunkName: "Info" */ '@/pc/views/Index'), name: 'BRAND CONCEPT', label: 'BrandConcept', id: '4-1' },
        // 主頁書籤_介紹萬達
        { path: '/#devArea', component: () => import(/* webpackChunkName: "Info" */ '@/pc/views/Index'), name: 'DEVELOPMENT PROCESS', label: 'DevelopmentProcess', id: '5-1' },
        // 主頁書籤_介紹萬達
        { path: '/#techArea', component: () => import(/* webpackChunkName: "Info" */ '@/pc/views/Index'), name: 'TECHNICAL SUPPORT', label: 'TechnicalSupport', id: '6-1' }
      ]
    }
  ],
  defaultRoutesMobile: [
    {
      path: '/mobile/',
      name: 'Main',
      component: MainMobile,
      children: [
        { path: '/mobile/index', component: IndexMobile, name: 'index' },
        { path: '/mobile/info', component: () => import(/* webpackChunkName: "Info" */ '@/mobile/views/Info'), name: 'info' }
      ]
    }
  ]
})
